/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import moment from "moment";

import { DataGrid } from "@mui/x-data-grid";
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  Box,
  Autocomplete,
  IconButton,
  Grid,
  Typography,
  // FormGroup,
  // FormControlLabel,
} from "@mui/material";
import { createFilterOptions } from "@mui/material/Autocomplete";
import Dialog from "src/components/core/Dialog";
import Button from "src/components/core/Button";
import TextField from "src/components/core/TextField";

import CloseIcon from "@mui/icons-material/Close";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";

import font from "src/styles/font";
import { Black, DarkGrey, Primary } from "src/styles/color";
import { convertPrice, formatFromElastic } from "src/common";
import { useDialog } from "src/context/DialogContext";
import { UseUpload } from "src/context/UploadProductContext";
import Checkbox from "src/components/core/Checkbox";

import { findAllDealGroup } from "src/api/promoCode";
import { searchProduct } from "src/api/product";

const WrapperTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: ${font.size.md};
  font-weight: 500;
  color: ${Black};
`;

const ImageNoData = styled.image`
  width: 120px;
  height: 120px;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/no+data.svg");
  background-repeat: no-repeat;
  background-size: 100%;
`;

const TextNoData = styled.pre`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
`;

const ImageEmpty = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 80px;
  height: 80px;
  background: #f2f1f3;
  border-radius: 16px;
  object-fit: cover;
  object-position: center;
  cursor: pointer;
  vertical-align: initial;
  flex-shrink: 0;

  &:hover {
    opacity: 0.8;
  }

  &.active {
    border: 2px solid #707070;
  }
`;

const ImgDisplay = styled.img`
  width: 80px;
  height: 80px;
  object-fit: cover;
  object-position: center;
  border-radius: 16px;
  flex-shrink: 0;
`;

const ImageNotFound = styled.div`
  width: 120px;
  height: 120px;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/not+found.svg");
  background-repeat: no-repeat;
  background-size: 100%;
`;

const WrapperDataGrid = styled.div`
  height: 600px;
  width: 100%;
  .MuiDataGrid-root {
    border: 1px solid #ffffff;
  }
  .MuiDataGrid-columnHeaders {
    background-color: #f5f5f5;
  }
  .MuiDataGrid-root .MuiDataGrid-columnSeparator--sideRight {
    color: #f5f5f5;
  }
  .MuiDataGrid-root .MuiDataGrid-columnHeader:focus-within {
    // outline: solid #f5f5f5 1px;
    outline: none;
  }
  .MuiDataGrid-root .MuiDataGrid-cell:focus {
    outline: none;
    border-bottom: solid #f5f5f5 1px 0 1px 0;
  }
  .MuiDataGrid-root .MuiDataGrid-row.Mui-selected {
    background-color: #ffffff;
  }
  .MuiCheckbox-root.Mui-checked {
    color: var(--primary-color);
  }
`;

function NoRowsOverlay() {
  return (
    <Stack height="100%" alignItems="center" justifyContent="center">
      <ImageNoData></ImageNoData>
      <TextNoData>No Data</TextNoData>
    </Stack>
  );
}

function NoResultsOverlay() {
  return (
    <Stack height="100%" alignItems="center" justifyContent="center">
      <ImageNotFound />
      <TextNoData>Not Found</TextNoData>
    </Stack>
  );
}

const AddProductDialog = ({
  onClose,
  onAppendData,
  selectedData = [],
  productGroup = "all",
}) => {
  const hasPageBeenRendered = useRef(false);
  const hasSelectedProductSeted = useRef(false);
  const { openDialog } = useDialog();
  const { masterdata } = UseUpload();
  const { brand_data, productType_data } = masterdata;

  const isReady = productGroup === "ready" ? true : false;
  const isPreOrder = productGroup === "pre-order" ? true : false;

  const [dataProductList, setDataProductList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [dealGroup, setDealGroup] = useState([]);
  const [searchParams, setSearchParams] = useState({
    keyword: "",
    brand: [],
    product_type: [],
    deal_group_id: [],
    ready_to_sell: isReady,
    pre_order: isPreOrder,
  });

  const [selectedProduct, setSelectedProduct] = useState(selectedData);

  const isFormValid = selectedProduct?.length > 0;

  useEffect(() => {
    setSelectedProduct(selectedData);
  }, [selectedData]);

  // useEffect(() => {
  //   console.log("===== selectedProduct ====", selectedProduct);
  // }, [selectedProduct]);

  const columns = [
    {
      field: "_id",
      headerName: "ชื่อสินค้า/รหัส",
      flex: 4,
      sortable: false,
      align: "left",
      userRoles: [1],
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              py: "10px",
            }}
          >
            {!!params?.row?.group_image?.product_display_image === false ? (
              <ImageEmpty>
                <InsertPhotoIcon
                  sx={{
                    color: "rgba(0, 0, 0, 0.54)",
                    cursor: "pointer",
                  }}
                />
              </ImageEmpty>
            ) : (
              <ImgDisplay
                src={
                  params?.row?.group_image?.product_display_image
                  // ? params?.row?.group_image?.product_display_image.replace(
                  //     ".com",
                  //     ".com/300x300"
                  //   )
                  // : ""
                }
                alt=""
              />
            )}
            <Stack
              gap={1}
              sx={{
                ml: 2,
                "& .MuiTypography-root": {
                  fontSize: font.size.sm,
                },
                "& span.MuiTypography-root": {
                  color: DarkGrey,
                },
              }}
            >
              <Typography component="p">
                {params?.row?.product?.item_name}
              </Typography>
              <Typography component="span">
                {params?.row?.product?.item_code}
              </Typography>
              {!!params?.row?.name && (
                <Typography component="span">{params?.row?.name}</Typography>
              )}
            </Stack>
          </Box>
        );
      },
    },
    {
      field: "company_name",
      headerName: "แบรนด์",
      flex: 2,
      sortable: false,
      headerAlign: "left",
      align: "left",
      userRoles: [1],
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography
            component="p"
            sx={{
              "&.MuiTypography-root": {
                fontSize: font.size.sm,
              },
            }}
          >
            {params?.row?.product?.brand?.name}
          </Typography>
        </Box>
      ),
    },
    {
      field: "updatedAt",
      headerName: "Updated Date",
      flex: 3,
      sortable: true,
      headerAlign: "center",
      align: "center",
      userRoles: [1],
      renderCell: (params) =>
        moment(params?.row?.product_choice_deal?.updatedAt).format(
          "DD-MM-YYYY"
        ),
    },
    {
      field: "price",
      headerName: "Price",
      flex: 2,
      sortable: false,
      headerAlign: "center",
      align: "center",
      userRoles: [1],
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography
            component="p"
            sx={{
              "&.MuiTypography-root": {
                fontSize: font.size.sm,
              },
            }}
          >
            {`${convertPrice(
              params?.row?.group_price?.is_start_price === true
                ? params?.row?.group_price?.start_price
                : params?.row?.group_price.special_price > 0 &&
                  params?.row?.group_price.special_price !== null &&
                  params?.row?.group_price.special_price !== undefined
                ? params?.row?.group_price.special_price
                : params?.row?.group_price?.price
            )}`}
          </Typography>
        </Box>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      flex: 2,
      sortable: false,
      headerAlign: "center",
      align: "center",
      userRoles: [1],
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography
            component="p"
            sx={{
              "&.MuiTypography-root": {
                fontSize: font.size.sm,
              },
            }}
          >
            {params?.row?.product?.status}
          </Typography>
        </Box>
      ),
    },
  ];

  const fetchProduct = async () => {
    try {
      setIsLoading(true);
      await searchProduct({
        keyword: searchParams.keyword,
        brand: searchParams.brand?.map((item) => item._id)?.join(),
        product_type: searchParams.product_type
          ?.map((item) => item._id)
          ?.join(),
        deal_group_id: searchParams.deal_group_id
          ?.map((item) => item._id)
          ?.join(),
        pre_order: searchParams.pre_order ? true : null,
        ready_to_sell: searchParams.ready_to_sell ? true : null,
      }).then(async ({ data }) => {
        // console.log('----- data ----', data)
        setDataProductList(
          data?.rows.length > 0
            ? data?.rows?.map((product) => ({
                ...formatFromElastic(product),
              }))
            : []
        );
        if (!!selectedData) setSelectedProduct(selectedData);
      });
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
      if (!hasPageBeenRendered.current) {
        hasPageBeenRendered.current = true;
      }
    }
  };

  const fetchDealGroup = async () => {
    try {
      const data = await findAllDealGroup();
      setDealGroup(data);
    } catch (err) {
      console.error(err);
    } finally {
      if (!hasPageBeenRendered.current) {
        hasPageBeenRendered.current = true;
      }
    }
  };

  const handleOnClose = () => {
    openDialog({
      type: "confirm",
      title: `คุณต้องการออกจากหน้านี้ใช่หรือไม่`,
      onConfirm: () => {
        onClose();
      },
      maxWidth: 342,
    });
  };

  const handleSubmit = async () => {
    const allSeletedProducts = [...selectedData, ...selectedProduct];
    const mapAllProducts = new Map(
      allSeletedProducts.map((product) => [product._id, product])
    );
    const uniqueProducts = [...mapAllProducts.values()];
    onAppendData(uniqueProducts);
  };

  useEffect(() => {
    if (productGroup === "ready") {
      setSearchParams({
        ...searchParams,
        ready_to_sell: true,
      });
    } else if (productGroup === "pre-order") {
      setSearchParams({
        ...searchParams,
        pre_order: true,
      });
    }
    fetchProduct();
    fetchDealGroup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (hasPageBeenRendered.current) {
      fetchProduct();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    searchParams.keyword,
    JSON.stringify(searchParams?.brand),
    JSON.stringify(searchParams?.product_type),
    JSON.stringify(searchParams.deal_group_id),
  ]);

  return (
    <Dialog
      onClose={handleOnClose}
      aria-labelledby="customized-dialog-title"
      open={true}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: 1024,
            maxWidth: "100%",
          },
        },
        "& .MuiDialogContent-root": {
          pt: 1,
          pb: 4,
        },
      }}
    >
      <DialogTitle sx={{ p: 3 }}>
        <WrapperTitle>เลือกสินค้าสำหรับการใช้ส่วนลด</WrapperTitle>

        <IconButton
          aria-label="close"
          onClick={handleOnClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {/* filter */}
        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={3.9}>
            <TextField
              label="ค้นจากชื่อหรือรหัสสินค้า"
              variant="outlined"
              fullWidth
              value={searchParams?.keyword}
              onChange={(e) => {
                // console.log("newValue", newValue);
                setSearchParams({
                  ...searchParams,
                  keyword: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={2.7}>
            <Autocomplete
              // freeSolo
              multiple
              limitTags={1}
              aria-required={true}
              id="brand-product-select"
              getOptionSelected={(option, value) => option?._id === value?._id}
              isOptionEqualToValue={(option, value) =>
                option?._id === value?._id
              }
              disableCloseOnSelect
              renderOption={(props, option, { selected }) => {
                const { key, ...optionProps } = props;
                return (
                  <li key={key} {...optionProps}>
                    <Checkbox
                      sx={{
                        mr: 1,
                        "&.Mui-checked": {
                          color: "#e04132",
                        },
                      }}
                      checked={selected}
                    />
                    {option.name}
                  </li>
                );
              }}
              options={brand_data}
              value={searchParams.brand}
              onChange={(_, newValue) => {
                // console.log("newValue", newValue);
                setSearchParams({
                  ...searchParams,
                  brand: newValue,
                });
              }}
              getOptionLabel={(option) => option?.name}
              renderTags={(value) => {
                // return `แบรนด์สินค้า (${value.length})`
                return null;
              }}
              filterOptions={createFilterOptions({
                matchFrom: "any",
                limit: 100,
              })}
              sx={{
                // mt: 2,
                // mb: 3,
                width: "100%",
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  // placeholder={searchParams.brand.length < 1 && `แบรนด์สินค้า`}
                  placeholder={`แบรนด์สินค้า${
                    searchParams?.brand?.length > 0
                      ? ` (${searchParams?.brand?.length})`
                      : ``
                  }`}
                />
              )}
            />
          </Grid>

          <Grid item xs={2.7}>
            <Autocomplete
              // freeSolo
              multiple
              limitTags={1}
              aria-required={true}
              id="product-type-product-select"
              getOptionSelected={(option, value) => option?._id === value?._id}
              isOptionEqualToValue={(option, value) =>
                option?._id === value?._id
              }
              disableCloseOnSelect
              renderOption={(props, option, { selected }) => {
                const { key, ...optionProps } = props;
                return (
                  <li key={key} {...optionProps}>
                    <Checkbox
                      sx={{
                        mr: 1,
                        "&.Mui-checked": {
                          color: "#e04132",
                        },
                      }}
                      checked={selected}
                    />
                    {option.type_th}
                  </li>
                );
              }}
              options={productType_data}
              value={searchParams.product_type}
              onChange={(_, newValue) => {
                // console.log("newValue", newValue);
                setSearchParams({
                  ...searchParams,
                  product_type: newValue,
                });
              }}
              getOptionLabel={(option) => option?.type_th}
              renderTags={(value) => {
                // return `ประเภทสินค้า (${value.length})`
                return null;
              }}
              filterOptions={createFilterOptions({
                matchFrom: "any",
                limit: 100,
              })}
              sx={{
                // mt: 2,
                // mb: 3,
                width: "100%",
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  // placeholder={searchParams.product_type.length < 1 && `ประเภทสินค้า`}
                  placeholder={`ประเภทสินค้า${
                    searchParams?.product_type?.length > 0
                      ? ` (${searchParams?.product_type?.length})`
                      : ``
                  }`}
                />
              )}
            />
          </Grid>

          <Grid item xs={2.7}>
            <Autocomplete
              // freeSolo
              multiple
              limitTags={1}
              aria-required={true}
              id="deal-group-product-select"
              getOptionSelected={(option, value) => option?._id === value?._id}
              isOptionEqualToValue={(option, value) =>
                option?._id === value?._id
              }
              disableCloseOnSelect
              renderOption={(props, option, { selected }) => {
                const { key, ...optionProps } = props;
                return (
                  <li key={key} {...optionProps}>
                    <Checkbox
                      sx={{
                        mr: 1,
                        "&.Mui-checked": {
                          color: "#e04132",
                        },
                      }}
                      checked={selected}
                    />
                    {option?.name}
                  </li>
                );
              }}
              options={dealGroup}
              value={searchParams?.deal_group_id}
              onChange={(_, newValue) => {
                // console.log("newValue", newValue);
                setSearchParams({
                  ...searchParams,
                  deal_group_id: newValue,
                });
              }}
              getOptionLabel={(option) => option?.name}
              renderTags={(value) => {
                // return `สินค้าในดีล (${value.length})`
                return null;
              }}
              // filterOptions={createFilterOptions({
              //   matchFrom: "any",
              //   limit: 100,
              // })}
              sx={{
                // mt: 2,
                // mb: 3,
                width: "100%",
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  // placeholder={searchParams.deal_group_id.length < 1 && `ประเภทสินค้า`}
                  placeholder={`สินค้าในดีล${
                    searchParams?.deal_group_id?.length > 0
                      ? ` (${searchParams?.deal_group_id?.length})`
                      : ``
                  }`}
                />
              )}
            />
          </Grid>
        </Grid>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            // justifyContent: "space-between",
            mb: 2,
          }}
        >
          <Box sx={{ mr: 3 }}>
            <Typography
              sx={{
                mr: 1,
                color: DarkGrey,
              }}
              component="span"
            >
              สินค้าที่เลือกทั้งหมด :
            </Typography>
            <Typography
              sx={{
                color: Primary,
              }}
              component="span"
            >
              {selectedProduct.length}
            </Typography>
          </Box>

          {/* <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={searchParams.ready_to_sell}
                  disabled={isReady || isPreOrder}
                  onChange={(e) => {
                    setSearchParams({
                      ...searchParams,
                      ready_to_sell: e.target.checked,
                    });
                  }}
                  name="gilad"
                />
              }
              label="เฉพาะสินค้าพร้อมส่ง"
            />
          </FormGroup> */}
        </Box>

        <WrapperDataGrid>
          <DataGrid
            rows={dataProductList}
            getRowId={(row) => row._id}
            getRowHeight={() => "auto"}
            loading={isLoading}
            columns={columns}
            onSelectionModelChange={(ids) => {
              // console.log("--- ids ----", ids, hasSelectedProductSeted.current);
              if (
                !hasSelectedProductSeted.current &&
                selectedProduct.length > 0
              ) {
                hasSelectedProductSeted.current = true;
              } else if (
                !hasSelectedProductSeted.current &&
                selectedProduct.length === 0
              ) {
                hasSelectedProductSeted.current = true;
                const selectedIDs = new Set(ids);
                const selectedRowData = dataProductList.filter((row) =>
                  selectedIDs.has(row._id.toString())
                );
                // if (selectedData.length > 0) {}
                setSelectedProduct(selectedRowData);
              } else {
                const selectedIDs = new Set(ids);
                const selectedRowData = dataProductList.filter((row) =>
                  selectedIDs.has(row._id.toString())
                );
                setSelectedProduct(selectedRowData);
              }
            }}
            selectionModel={selectedProduct.map((product) => product._id)}
            pageSize={10}
            pagination
            checkboxSelection
            components={{
              NoRowsOverlay,
              NoResultsOverlay,
            }}
            componentsProps={{
              basePopper: {},
            }}
            hideFooterSelectedRowCount
            disableSelectionOnClick
            disableColumnMenu
          />
        </WrapperDataGrid>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "center",
        }}
      >
        <Button
          variant="outlined"
          size="large"
          onClick={handleOnClose}
          sx={{
            minWidth: 160,
          }}
        >
          ยกเลิก
        </Button>
        <Button
          variant="contained"
          size="large"
          onClick={() => {
            openDialog({
              type: "confirm",
              title: `คุณต้องการเพิ่มสินค้าใช่หรือไม่`,
              onConfirm: () => {
                handleSubmit();
              },
              maxWidth: 342,
            });
          }}
          sx={{
            minWidth: 160,
          }}
          // autoFocus // enable auto focus to increase accessibility
          disabled={!isFormValid}
        >
          แนบสินค้า
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddProductDialog;
